import { useOrganizations } from "@/application/workflows/organization";
import { getOrgStorageService } from "@/infrastructure/di/services";

export const useOrganizationSetup = (
  pathname: string,
  search: string,
  options: { loadDetails?: boolean } = {},
) => useOrganizations({ pathname, search, storage: getOrgStorageService(), ...options });
